import { useFormContext } from "react-hook-form";
import { Checkbox, FormControlLabel } from "@mui/material";
import useCompany from "$hooks/useCompany";
import CField, { CFieldInputProps } from "$forms/CField";

import CompanySelect from "$forms/CompanySelect";
import { useStyles } from "../styles/CompanyForm.styles";
import { CompanyType } from "$types";

type Props = {
  companyTypes: CompanyType[];
  readOnlyFields: string[];
};

export default function RelationshipsDetails({
  companyTypes,
  readOnlyFields,
}: Props) {
  const classes = useStyles();
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const { isAgency, isClient, isContributor, isSupplier } = useCompany();

  return (
    <>
      {isAgency(companyTypes) && (
        <CField
          control={control}
          name="relayPoint"
          error={errors.relayPoint}
          label="Point relais"
        >
          {(props: CFieldInputProps) => (
            <FormControlLabel
              control={<Checkbox {...props} color="primary" />}
              label={props.label}
              style={{ width: "fit-content" }}
              checked={props.value}
            />
          )}
        </CField>
      )}

      {isContributor(companyTypes) && (
        <div className={classes.formRow}>
          <CField
            control={control}
            name="contributorOf"
            required
            error={errors.contributorOf}
            label="Entreprise(s) cliente(s) rattachée(s)"
          >
            {(props: CFieldInputProps) => (
              <CompanySelect
                companyTypes={[CompanyType.CLIENT]}
                multiple
                disabled={readOnlyFields.includes("contributorOf")}
                {...props}
                ignoreSideBarCompanyFilter
                minCharsToTrigerSearch={0}
                rowsPerPage={99999}
              />
            )}
          </CField>
        </div>
      )}

      {isClient(companyTypes) && (
        <div className={classes.formRow}>
          <CField
            control={control}
            name="contributingCompanies"
            error={errors.contributingCompanies}
            label="Entreprise(s) intervenante(s) rattachée(s) à l'entreprise cliente"
          >
            {(props: CFieldInputProps) => (
              <CompanySelect
                companyTypes={[CompanyType.CONTRIBUTOR]}
                multiple
                {...props}
                ignoreSideBarCompanyFilter
                minCharsToTrigerSearch={0}
                rowsPerPage={99999}
              />
            )}
          </CField>
        </div>
      )}

      {isSupplier(companyTypes) && (
        <div className={classes.formRow}>
          <CField
            control={control}
            name="supplierOf"
            error={errors.supplierOf}
            required
            label="Entreprise(s) cliente(s) rattachée(s) au fournisseur"
          >
            {(props: CFieldInputProps) => (
              <CompanySelect
                companyTypes={[CompanyType.CLIENT]}
                multiple
                {...props}
                minCharsToTrigerSearch={0}
                rowsPerPage={99999}
                ignoreSideBarCompanyFilter
              />
            )}
          </CField>
        </div>
      )}
    </>
  );
}
